import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { formatAmount } from 'helpers/helpers';
import useGeneralStyles from 'apps/Pdf/styles/general';
import useStyles from 'apps/Pdf/templates/InvestmentQuestionnaire/components/QuestionsAndAnswersStyle';
import { Currency } from 'enums';

interface Props {
  label: string;
  optionLabel?: string;
  htmlLabel?: boolean;
  answer: string | boolean;
  answers?: string[];
  other?: string;
  amount?: number;
  currency?: Currency;
  currencyInAnswer?: boolean;
  details?: { [key: string]: string | string[] };
}

const QuestionAndAnswer = (props: Props) => {
  const styles = useGeneralStyles();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container className={classes.qa}>
      <Grid item xs={6}>
        <span
          dangerouslySetInnerHTML={{
            __html: t(`contract_aml_${props.label}`, {
              interpolation: { escapeValue: !!props.htmlLabel },
            }),
          }}
        />
      </Grid>
      <Grid item xs={6}>
        {props.answers ? (
          <ul>
            {props.answers.map((value, i) => {
              const cssClass = props.answer === value ? `${styles.bold} ${styles.value}` : undefined;
              return (
                <li className={cssClass} key={value}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(
                        `contract_aml_${props.optionLabel ? props.optionLabel : props.label}_${value}${
                          props.currencyInAnswer ? '_' + props.currency : ''
                        }`,
                        {
                          interpolation: { escapeValue: !!props.htmlLabel },
                        },
                      ),
                    }}
                  />
                  {props.answer === value && props.answer === 'OTHER' && ` - ${props.other}`}
                  {props.answer === value &&
                    props.amount !== undefined &&
                    props.amount > 0 &&
                    ` o objemu ${formatAmount({ value: props.amount }, props.currency!)} `}
                </li>
              );
            })}
          </ul>
        ) : (
          <span className={`${styles.bold} ${styles.value} ${classes.binary}`}>
            {props.answer === true ? t('general_yes') : t('general_no')}
            {props.other && ` - ${props.other}`}
          </span>
        )}
      </Grid>
      <Grid item xs={12}>
        {props.answer === true &&
          props.details &&
          Object.keys(props.details).map((key: string) => {
            return (
              <>
                {Array.isArray(props.details![key]) ? (
                  (props.details![key] as Array<string>).map((detail, i) => {
                    return detail !== '' ? (
                      <div className={classes.detail} key={`${key}_${i}`}>
                        {t(`contract_aml_${key}`)} {i + 1}: <span className={`${styles.value}`}>{detail}</span>
                      </div>
                    ) : null;
                  })
                ) : (
                  <div className={classes.detail} key={key}>
                    {t(`contract_aml_${key}`)}: <span className={`${styles.value}`}>{props.details![key]}</span>
                  </div>
                )}
              </>
            );
          })}
      </Grid>
    </Grid>
  );
};

export default QuestionAndAnswer;
